import React from 'react';
import classnames from 'classnames';
import { PopoverPlaceEnum } from 'common/components/core/popover/popOverFactory';
import { customEditableFieldFactory } from 'common/components/core/common/CustomEditableField';
import ReactTelInput from './ReactTelInput';
import theme from './EditableTelInput.scss';

const EditableTelInput = customEditableFieldFactory({
    ActiveFieldComponent: ({ updateValue, className, error, ...rest }) => (
        <ReactTelInput
            {...rest}
            error={error}
            className={classnames(className, { [theme.error]: error })}
            theme={theme}
            place={PopoverPlaceEnum.Right}
            onChange={updateValue}
        />
    )
});

export default EditableTelInput;
